export default {
    autoplay: false,
    observer: true,
    observeParents: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    loop: false,
    centeredSlides: false,
    spaceBetween: 0,
    grabCursor: true,
    breakpoints: {
        320: {
            slidesPerView: 1,
            // spaceBetween: 10
        },

        576: {
            slidesPerView: 2,
            // spaceBetween: 15
        },

        768: {
            slidesPerView: 2.75,
            // spaceBetween: 10
        },
        991: {
            slidesPerView: 3,
            // spaceBetween: 15
        },
        1280: {
            slidesPerView: 3.25,
        },
        1560: {
            slidesPerView: 4.25,
            // spaceBetween: 20
        },
        // 4k screens
        2400: {
            slidesPerView: 6,
            // spaceBetween: 208h
        },
        // 5k screens
        3700: {
            slidesPerView: 9,
            // spaceBetween: 20
        },
    }
};